module.exports = __webpack_public_path__ + "img/position copy.5e393ca4.png";